import styled from 'styled-components';

import { Text, Input, TextArea, Button as YogaButton } from '@gympass/yoga';

import { Button } from '../../components/Button';

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  justify-items: start;
  text-align: left;
  width: ${({ theme }) => theme.yoga.sizes.notesModalWidth}px;
`;

export const Body = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.yoga.spacing.xlarge}px;
`;

export const InputTitle = styled(Input)`
  :disabled {
    color: ${({ theme }) => theme.yoga.colors.text.primary};
  }
`;

export const InputMessage = styled(TextArea)`
  textarea {
    :disabled {
      color: ${({ theme }) => theme.yoga.colors.text.primary};
    }
  }
  fieldset {
    height: ${({ theme }) => theme.yoga.sizes.notesInputMessageHeight}px;
  }
`;

export const Title = styled(Text.H5)`
  width: 100%;
`;

export const Message = styled(Text.H4)`
  text-align: center;
  width: 100%;
`;

export const ActionsContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: auto;
`;

export const CancelButton = styled(props => <Button {...props} />)`
  background-color: ${({ theme }) => theme.yoga.colors.text.disabled};
  margin-right: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  &:hover {
    background-color: ${({ theme }) => theme.yoga.colors.error} !important;
  }
`;

export const NotesButton = styled(props => <Button {...props} />)`
  color: white;
  margin-top: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const NotesDeleteButton = styled(YogaButton.Link)`
  color: ${({ theme }) => theme.yoga.colors.primary};
  margin-top: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const Instructions = styled(Text.Small)`
  color: ${({ theme }) => theme.yoga.colors.textSecondary};
  margin-bottom: ${({ theme }) => theme.yoga.spacing.small}px;
`;

export const Confirm = styled.div`
  align-items: center;
  display: grid;
  gap: ${({ theme }) => theme.yoga.spacing.xxxlarge}px;
  grid-auto-flow: column;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.medium}px;
`;

export const Motive = styled(TextArea)`
  margin-bottom: ${({ theme }) => theme.yoga.spacing.large}px;
`;
